module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-9.800f2c12.png";